import "./index.less";

import React, { useRef } from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";

export interface LoginPanelContentProps {
    transitionKey: React.Key;
    children: React.ReactNode;
}

export const LoginPanelContent: React.FC<LoginPanelContentProps> = ({
    transitionKey,
    children,
}) => {
    const nodeRef = useRef(null);
    return (
        <TransitionGroup className="login-panel-content">
            <CSSTransition
                key={transitionKey}
                unmountOnExit
                classNames="slider-in"
                nodeRef={nodeRef}
                timeout={400}
            >
                <div ref={nodeRef}>{children}</div>
            </CSSTransition>
        </TransitionGroup>
    );
};
